import { Modal, Alert, Button, Form } from "@deere/ux.uxframe-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { COO_DISCLAIMER_URL } from "../../utils/constEnvVariables";

export default function CooAgreementPopup({ showAgreement, setshowAgreement, submitResponse }) {
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    submitResponse();
    setshowAgreement(false);
  };

  return (
    <Modal show={showAgreement} onHide={() => setshowAgreement(false)} size="lg">
      <Form validated={true} onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{t("cm_lbl_agreemet_modal")}</Modal.Title>
        </Modal.Header>
        <Modal.Body scrollable={false} style={{ maxHeight: "325px", overflowY: "auto" }}>
          <Alert variant="warning">
            <h5 className="uxf-alert-title" style={{textAlign:"justify", textAlignLast:"left"}}>
              {t("coo_disclaimer_msg")}
            </h5>
            <h5 className="uxf-alert-title">
              <a href={COO_DISCLAIMER_URL} target="_blank">{COO_DISCLAIMER_URL}</a>
            </h5>
          </Alert>
          <br />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setshowAgreement(false)}>
            {t("btn_cancel")}
          </Button>
          <Button variant="primary" onClick={handleSubmit} type="submit">
            {t("btn_review_submit")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
